import { render, staticRenderFns } from "./LabelManagerDialog.vue?vue&type=template&id=6c80f6d6&scoped=true"
import script from "./LabelManagerDialog.vue?vue&type=script&lang=js"
export * from "./LabelManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelManagerDialog.vue?vue&type=style&index=0&id=6c80f6d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80f6d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c80f6d6')) {
      api.createRecord('6c80f6d6', component.options)
    } else {
      api.reload('6c80f6d6', component.options)
    }
    module.hot.accept("./LabelManagerDialog.vue?vue&type=template&id=6c80f6d6&scoped=true", function () {
      api.rerender('6c80f6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/shop/components/LabelManagerDialog.vue"
export default component.exports